 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50":"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50","activities":"activities","add-country~add-resource~add-safari-package~edit-country~edit-resource~edit-safari-package~users":"add-country~add-resource~add-safari-package~edit-country~edit-resource~edit-safari-package~users","users":"users","countries":"countries","days":"days","destination-packages":"destination-packages","destinations":"destinations","experience-packages~experiences":"experience-packages~experiences","experience-packages":"experience-packages","experiences":"experiences","home~safari-packages":"home~safari-packages","home":"home","safari-packages":"safari-packages","quotations":"quotations","safari-types":"safari-types","safari-types-packages":"safari-types-packages","add-country":"add-country","add-resource":"add-resource","add-safari-package":"add-safari-package","edit-country":"edit-country","edit-resource":"edit-resource","edit-safari-package":"edit-safari-package","login":"login","payment":"payment","resources":"resources","reviews":"reviews"}[chunkId]||chunkId) + "." + {"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50":"8194edf3","activities":"bc0a4ddd","add-country~add-resource~add-safari-package~edit-country~edit-resource~edit-safari-package~users":"8be2a9da","users":"bfa416ea","countries":"29da9752","days":"7d32359e","destination-packages":"39297a91","destinations":"fcba1b3e","experience-packages~experiences":"d4518531","experience-packages":"46acd662","experiences":"f96d799e","home~safari-packages":"04a4806f","home":"b075cb04","safari-packages":"ef5c368f","quotations":"e7bdacf6","safari-types":"b286b723","safari-types-packages":"d3823468","add-country":"8b92a53a","add-resource":"6489487c","add-safari-package":"29b38141","edit-country":"2b49b1b7","edit-resource":"2f238d9a","edit-safari-package":"90e8e13d","login":"d5d8d1e5","payment":"4b1a41d9","resources":"6ff33b6c","reviews":"a04d4e45"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50":1,"activities":1,"users":1,"countries":1,"days":1,"destination-packages":1,"destinations":1,"experience-packages~experiences":1,"experience-packages":1,"experiences":1,"home~safari-packages":1,"home":1,"safari-packages":1,"quotations":1,"safari-types":1,"safari-types-packages":1,"add-country":1,"add-resource":1,"add-safari-package":1,"edit-country":1,"edit-resource":1,"edit-safari-package":1,"login":1,"payment":1,"resources":1,"reviews":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50":"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50","activities":"activities","add-country~add-resource~add-safari-package~edit-country~edit-resource~edit-safari-package~users":"add-country~add-resource~add-safari-package~edit-country~edit-resource~edit-safari-package~users","users":"users","countries":"countries","days":"days","destination-packages":"destination-packages","destinations":"destinations","experience-packages~experiences":"experience-packages~experiences","experience-packages":"experience-packages","experiences":"experiences","home~safari-packages":"home~safari-packages","home":"home","safari-packages":"safari-packages","quotations":"quotations","safari-types":"safari-types","safari-types-packages":"safari-types-packages","add-country":"add-country","add-resource":"add-resource","add-safari-package":"add-safari-package","edit-country":"edit-country","edit-resource":"edit-resource","edit-safari-package":"edit-safari-package","login":"login","payment":"payment","resources":"resources","reviews":"reviews"}[chunkId]||chunkId) + "." + {"activities~countries~days~destination-packages~destinations~experience-packages~experiences~home~quo~bb110f50":"f8fb40b0","activities":"4b4b7f41","add-country~add-resource~add-safari-package~edit-country~edit-resource~edit-safari-package~users":"31d6cfe0","users":"347875b6","countries":"cc09bba9","days":"5ae95ce8","destination-packages":"e18d72eb","destinations":"e56628ab","experience-packages~experiences":"a94cca19","experience-packages":"e0080240","experiences":"9c3918b8","home~safari-packages":"24a4942e","home":"a9af3c2b","safari-packages":"5012c3a9","quotations":"e157fe9b","safari-types":"f06bd246","safari-types-packages":"b2349703","add-country":"532eb42d","add-resource":"84f20329","add-safari-package":"162304de","edit-country":"807550b3","edit-resource":"24d65ccc","edit-safari-package":"5e18f274","login":"5bfceb7c","payment":"173a1ccc","resources":"1f98cc56","reviews":"0fa94ecc"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
